import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

const allowedDateFormats = [
  "MMM-YYYY",
  "MMMM-YYYY",
  "D-MM-YYYY",
  "D-MMM-YYYY",
  "D-MMMM-YYYY",
  "DD-MM-YYYY",
  "DD-MMM-YYYY",
  "DD-MMMM-YYYY",
  "DD/MM/YYYY",
  "YYYY-MM-DD",
];

export const capitalize = (str) =>
  str.trim().replace(/(\b[a-z](?!\s))/g, (c) => c.toUpperCase());

export const createDate = (d) => dayjs(capitalize(d), allowedDateFormats, true);

const isMonthInterval = (d) =>
  dayjs(capitalize(d), ["MMM-YYYY", "MMMM-YYYY"], true).isValid();

// export const debounce = (fn, delay) => {
//   let timer;
//   return (...args) => {
//     clearTimeout(timer);
//     timer = setTimeout(() => {
//       fn(...args);
//     }, delay);
//   };
// };

export const downloadCsvFile = ({
  data,
  delimiter = ",",
  fileName,
  headers = [],
  transformer,
}) => {
  delimiter = delimiter || ",";
  transformer = transformer || ((obj) => headers.map((prop) => obj[prop]));

  const csvHeader = (headers || []).join(delimiter);
  const csvContent = data.reduce((result, obj) => {
    const row = transformer(obj).join(delimiter);
    return `${result}\r\n${row}`;
  }, csvHeader);
  const byteOrderMark = "\ufeff";
  const blob = new Blob([byteOrderMark, csvContent], {
    type: "text/csv;charset=utf-8;",
  });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = fileName;
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const isBetweenDateInterval = ({ start, end }) => {
  const startDate = dayjs(start);
  const endDate = dayjs(end);
  return (strDate) => {
    const d = dayjs(strDate);
    return (
      (d.isSame(startDate, "day") || d.isAfter(startDate)) &&
      (d.isSame(endDate, "day") || d.isBefore(endDate))
    );
  };
};

export const formatCurrency = (value) =>
  new Intl.NumberFormat("en-US", {
    style: "decimal",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(value.replaceAll(",", ""));

export const formatDate = (d) =>
  createDate(d).format(isMonthInterval(d) ? "MMM-YYYY" : "DD-MMM-YYYY");

export const formatDateTime = (dt) => dayjs(dt).format("DD-MMM-YYYY HH:mm");

export const getUserFullName = (user) =>
  user ? `${user.firstName} ${user.lastName}` : "";

export const isValidDate = (d) => createDate(d).isValid();

export const toDateOnlyString = (d) => d.format("YYYY-MM-DD");

export const isFlownSegment = (segment) =>
  segment?.dD && new Date(segment?.dD) < new Date(toDateOnlyString(dayjs()));

export const segmentClass = (segment) => (segment?.c ? ` (${segment.c})` : "");

export const segmentFlightDateTime = (segment) =>
  segment?.dD ? " " + segment.dD + (segment?.dT ? " " + segment.dT : "") : "";

export const itinerarySegmentToString = (segment) =>
  `${segment.o}-${segment.d}${segmentClass(segment)}`;

export const ellipsis = (maxLength) => (str) =>
  `${str?.substring(0, maxLength)}${str?.length > maxLength ? "..." : ""}`;
